import React, { createContext, useEffect, useState } from 'react';

export const FeatureFlagContext = createContext<genericObject>({});

export const FeatureFlagProvider = (props: { children: JSX.Element }) => {
  const [featureFlags, setFeatureFlags] = useState<genericObject>({});

  useEffect(() => {
    const query = new URL(window.location.href).searchParams;
    const storage = window.localStorage;
    const urlFlags = Object.fromEntries(new URLSearchParams(query));
    const clear = urlFlags?.clear?.split(',') ?? [];

    const allFlags = {
      ...Object.fromEntries(Object.entries(storage)),
      ...Object.fromEntries(new URLSearchParams(query)),
    };

    clear.forEach((key: string) => {
      delete allFlags[key];
      window.localStorage.removeItem(key);
    });

    delete allFlags.clear;

    Object.entries(allFlags).forEach(([key, value]) =>
      window.localStorage.setItem(key, value),
    );

    setFeatureFlags(allFlags);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FeatureFlagContext.Provider value={featureFlags}>
      {props.children}
    </FeatureFlagContext.Provider>
  );
};
